//
// Copyright (c) 2021 Astute Global, Inc.
//

import $ from "jquery";
import { View } from "ckeditor5";

import "../css/templatePreviewView.css";

export default class TemplatePreviewView extends View {
  constructor(locale, id, statusId) {
    super(locale);
    this.id = id;
    this.statusId = statusId;
    this.set("rawHtml", null);
    this.setTemplate({
      tag: "div",
      attributes: {
        id: id,
        "aria-describedby": statusId,
        class: "template-preview",
      },
    });
    this.on("change:rawHtml", (evt, name, newValue) => this._renderRawHtml(newValue));
  }

  render() {
    super.render();
    this._renderRawHtml(this.rawHtml);
  }

  _renderRawHtml(rawHtml) {
    const el = $(this.element);
    if (rawHtml) {
      el.html(rawHtml);
      //block links from working
      el.find("a").on("click", (evt) => evt.preventDefault());
    } else {
      el.html("");
    }
  }
}
